import { Eye } from 'lucide-react';
import { HubContext, Submissions } from '../../types/hub';
import { useTranslation } from 'react-i18next';
import ProfileAvatar from '../common/ProfileAvatar';

interface SubmissionRowProps {
  item: Submissions[number];
  hub: HubContext;
  onSelectQuote: (id: string) => void;
}

export function SubmissionRow({ item, hub, onSelectQuote }: SubmissionRowProps) {
  const { t } = useTranslation('hub');

  return (
    <div className="grid grid-cols-6 items-center py-4">
      <div className="flex items-center gap-3">
        <ProfileAvatar
          profile_id={item.freelancer.id}
          first_name={item.freelancer.first_name}
          avatar_url={item.freelancer.avatar_url}
          className="w-10 h-10"
        />
        <div>
          <p className="font-medium">{item.freelancer.first_name}</p>
          <p className="text-sm text-gray-500">{item.freelancer.last_name}</p>
        </div>
      </div>

      <span className="text-xs bg-gray-100 rounded-full px-3 py-1 w-fit">
        {hub.job.visibility === 'public'
          ? t('submission_type_list.received_application', { ns: 'hub' })
          : t('submission_type_list.direct_request', { ns: 'hub' })}
      </span>

      <div>
        {item.totalAmount > 0 ? (
          <span className="font-semibold">{item.totalAmount} $</span>
        ) : (
          <span className="text-xs bg-gray-100 rounded-full px-3 py-1">{item.status}</span>
        )}
      </div>

      <span className="text-sm text-gray-600">
        {item.submitted_at ? new Date(item.submitted_at).toLocaleDateString() : '-'}
      </span>

      {/* Team */}
      <div className="flex space-x-2">
        {item.type === 'principal' &&
          item.teamMembers?.map((member, idx) => (
            <ProfileAvatar
              key={member.id ?? idx}
              profile_id={member.freelancer.id}
              first_name={member.freelancer.first_name}
              avatar_url={member.freelancer.avatar_url}
              className="w-8 h-8 border-2 border-white"
            />
          ))}
      </div>

      <button
        type="button"
        onClick={() => onSelectQuote(item.id)}
        className="ml-auto w-9 h-9 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50"
      >
        <Eye
          size={24}
          className={`text-gray-500 ${item.teamAvatars && item.teamAvatars.length > 0 ? 'text-primary' : ''}`}
        />
      </button>
    </div>
  );
}
